import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import pakt21ApiUrl from '../../common/pakt21ApiUrl';

export default class ListingStatusModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.status = this.attrs.status;
    this.requireReason = Boolean(this.attrs.requireReason);
    this.reason = Stream('');
  }

  className() {
    return 'Pakt21ListingStatusModal Modal--small';
  }

  title() {
    return app.translator.trans(`pakt21-beta.forum.listing.action_${this.status}_title`);
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <p className="helpText">
            {app.translator.trans(`pakt21-beta.forum.listing.action_${this.status}_help`)}
          </p>
          {this.requireReason ? (
            <div className="Form-group">
              <label for="pakt21-listing-status-reason">
                {app.translator.trans('pakt21-beta.forum.listing.reason')}
              </label>
              <textarea id="pakt21-listing-status-reason" className="FormControl" rows="5" maxlength="500" required bidi={this.reason} />
              <p className="helpText">{app.translator.trans('pakt21-beta.forum.listing.reason_help')}</p>
            </div>
          ) : null}
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}
              disabled={this.requireReason && !this.reason().trim()}>
              {app.translator.trans('pakt21-beta.forum.listing.confirm')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();
    const reason = this.reason().trim();
    if (this.loading || (this.requireReason && !reason)) return;
    this.loading = true;

    return app.request({
      method: 'POST',
      url: pakt21ApiUrl(app.forum.attribute('apiUrl'), `/pakt21/listings/${this.discussion.id()}/status`),
      body: { data: { type: 'pakt21-listings', attributes: { status: this.status, reason } } },
    }).then(() => app.store.find('discussions', this.discussion.id())).then(() => {
      this.hide();
      m.redraw();
    }).catch((error) => {
      this.loading = false;
      this.onerror(error);
    });
  }
}
